/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { slashText } from "@monsma/App/WidgetExtensions/MyListsDetails/MyListsDetailsExtension";
import { myListsDetailsOptionsStyles } from "@monsma/Overrides/Widgets/MyListsDetails/MyListsDetailsOptions";
import { screen } from "@monsma/XDL/Helpers";
import PlusCircle from "@monsma/XDL/Icons/PlusCircle";
import { css } from "styled-components";

(myListsDetailsOptionsStyles as any).slashText = {
    ...slashText,
    css: css`
        ${slashText?.css};

        ${screen("lte", "md")} {
            display: none;
        }
    `,
};

(myListsDetailsOptionsStyles as any).closeButton = {
    variant: "secondary",
    css: css`
        margin-left: 10px;
        margin-top: 24px;
    `,
};
(myListsDetailsOptionsStyles as any).uploadItemsBtn = {
    variant: "secondary",
    css: css`
        margin-left: 10px;
        margin-top: 24px;
    `,
};
(myListsDetailsOptionsStyles as any).overflowMenu = {
    css: css`
        top: 28px;
    `,
};
(myListsDetailsOptionsStyles as any).actionsWrapper = {
    css: css`
        display: inline-flex;
    `,
};
(myListsDetailsOptionsStyles as any).overflowMenuWrapper = {
    css: css`
        margin-top: 25px;
        padding-left: 10px;
    `,
};

myListsDetailsOptionsStyles.wrapper = {
    css: css`
        @media print {
            display: none;
        }
        display: flex;
        border-bottom: 1px solid ${getColor("common.border")};
        padding-bottom: 20px;
        margin-top: 35px;
    `,
};

myListsDetailsOptionsStyles.leftColumnWrapper = {
    css: css`
        display: flex;
        width: 100%;
    `,
};

myListsDetailsOptionsStyles.rightColumnWrapper = {
    css: css`
        display: flex;
        width: 35px;
        justify-content: center;
        margin-left: 10px;
        margin-top: 5px;
    `,
};

myListsDetailsOptionsStyles.container = {
    gap: 30,
};

myListsDetailsOptionsStyles.selectAllGridItem = {
    width: [12, 8, 6, 4, 4],
    css: css`
        align-items: center;
        justify-content: flex-start;

        ${screen("lte", "sm")} {
            justify-content: flex-start;
        }

        ${screen("gt", "md")} {
            max-width: 295px;
        }
    `,
};

myListsDetailsOptionsStyles.selectAll = {
    css: css`
        ${getProp("theme.checkbox.defaultProps.css")};
        cursor: pointer;
        margin-right: 30px;
    `,
};

myListsDetailsOptionsStyles.editSortOrder = {
    css: css`
        ${getProp("theme.checkbox.defaultProps.css")};
        cursor: pointer;
    `,
};

myListsDetailsOptionsStyles.searchGridItem = {
    width: [12, 12, 6, 4, 4],
    css: css`
        &&& {
            max-width: 262px;

            ${screen("lte", "sm")} {
                max-width: 100%;
            }
        }
    `,
};
myListsDetailsOptionsStyles.addItemsGridItem = {
    width: [12, 4, 4, 4, 4],
    css: css`
        align-items: center;

        ${screen("only", "sm")} {
            justify-content: flex-end;
        }
    `,
};

myListsDetailsOptionsStyles.addItemsLink = {
    icon: {
        iconProps: {
            src: PlusCircle,
            color: "common.ui5",
            size: 12,
            css: css`
                margin-right: 0;
            `,
        },
    },
    typographyProps: {
        css: css`
            padding-left: 5px;
        `,
    },
};

myListsDetailsOptionsStyles.uploadItemsModal = {
    sizeVariant: "large",
};
